import script from "./ChatProcessTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatProcessTimeline.vue?vue&type=script&setup=true&lang=js"

import "./ChatProcessTimeline.vue?vue&type=style&index=0&id=52ca8044&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52ca8044"]])

export default __exports__